const Share02Icon = /*#__PURE__*/ [
  ["path", { d: "M9 4.5C5.50442 5.70104 3 8.94175 3 12.7511C3 13.9579 3.25134 15.1076 3.70591 16.1534M15 4.5C18.4956 5.70104 21 8.94175 21 12.7511C21 13.7736 20.8195 14.7552 20.4879 15.6674M16.5 20.3296C15.1762 21.074 13.6393 21.5 12 21.5C10.3607 21.5 8.82378 21.074 7.5 20.3296", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "5", cy: "19", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "19", cy: "19", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export { Share02Icon as default };
//# sourceMappingURL=Share02Icon.js.map
